// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2P2Wc","row":"styles_row__3o59_"};